import React, { useState, useEffect } from "react";
import Wrapper from "./style";
import { NavLink, useLocation } from "react-router-dom"; // 👈 Import useLocation
import QuoteModal from "../get-quote/QuoteModal.jsx";
import { FiMenu, FiX } from "react-icons/fi";

// List of optimized collection items with precise labels and paths for SEO
const COLLECTIONS = [
  { path: "/lion-collection", label: "Marble Lion Statues" },
  { path: "/horse-collection", label: "Marble Horse Statues" },
  { path: "/elephant-collection", label: "Marble Elephant Statues" },
  { path: "/cow-collection", label: "Marble Cow Statues" },
  { path: "/dog-collection", label: "Marble Dog Statues" },
  { path: "/modern-art-collection", label: "Modern Marble Art" },
  { path: "/panel-collection", label: "Marble Wall Panels" },
  { path: "/god-collection", label: "Marble God Statues" },
];

const COLLECTION_PATHS = COLLECTIONS.map((c) => c.path);

const Navbar = () => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const location = useLocation(); // 👈 Use the location hook

  /* Check if any collection route is currently active */
  const isCollectionActive = COLLECTION_PATHS.some(path => 
    location.pathname.startsWith(path)
  );
    
  // ... (rest of the state and helper functions remain the same) ...

  const closeAllMenus = () => {
    setIsMobileMenuOpen(false);
    setOpenDropdown(false);
  };
  
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        isMobileMenuOpen &&
        !e.target.closest(".nav-links") &&
        !e.target.closest(".hamburger")
      ) {
        setIsMobileMenuOpen(false);
        setOpenDropdown(false);
      }

      if (
        openDropdown &&
        !e.target.closest(".dropdown")
      ) {
        setOpenDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isMobileMenuOpen, openDropdown]); 

  const closeMenuOnClick = () => {
    closeAllMenus();
  };
  
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (isMobileMenuOpen) {
      setOpenDropdown(false);
    }
  };

  const toggleDropdown = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setOpenDropdown(!openDropdown);
  };


  return (
    <Wrapper>
      {/* ... (Menu Overlay, Logo, Hamburger) ... */}
      <div
        className={`menu-overlay ${isMobileMenuOpen ? "open" : ""}`}
      ></div>

      <NavLink to="/" className="logo" onClick={closeMenuOnClick}>
        <img src='https://res.cloudinary.com/dancodp27/image/upload/f_auto,q_auto/v1764750124/for_now_final_logo_an7xps.png' alt="GSA Logo" width="80" height="80" />
        <h2>Gautam Stone Art</h2>
      </NavLink>

      <div
        className="hamburger"
        onClick={toggleMobileMenu}
        role="button"
        aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            toggleMobileMenu();
          }
        }}
      >
        {isMobileMenuOpen ? <FiX size={28} aria-hidden="true" /> : <FiMenu size={28} aria-hidden="true" />}
      </div>
      
      {/* NAV LINKS */}
      <ul className={`nav-links ${isMobileMenuOpen ? "open" : ""}`}>
        <li>
          <NavLink
            to="/"
            end // IMPORTANT: ensures HOME is only active at the root path "/"
            onClick={closeMenuOnClick}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            HOME
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/our-story"
            onClick={closeMenuOnClick}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            OUR STORY
          </NavLink>
        </li>

        {/* DROPDOWN - Apply 'active' class manually based on current path */}
        <li
          className={`dropdown ${isCollectionActive ? "active" : ""}`} // 👈 Apply active class here
          onClick={toggleDropdown}
        >
          <span className={isCollectionActive ? "active" : ""}>COLLECTIONS ▾</span> {/* 👈 And here for span style */}
          <ul className={`dropdown-menu ${openDropdown ? "open" : ""}`}>
            {COLLECTIONS.map((item) => (
              <li key={item.path}>
                <NavLink to={item.path} onClick={closeMenuOnClick}>
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </li>

        <li>
          <NavLink
            to="/contact"
            onClick={closeMenuOnClick}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            REACH US
          </NavLink>
        </li>

        {/* ... (Mobile Quote Button, Desktop Quote Button, Modal) ... */}
        <li className="mobile-quote">
            <button
                className="getquote"
                onClick={() => {
                    setIsModalOpen(true);
                    closeMenuOnClick();
                }}
            >
                Get a quote
            </button>
        </li>
      </ul>

      <button
        className="getquote desktop-quote"
        onClick={() => setIsModalOpen(true)}
      >
        Get a quote
      </button>

      <QuoteModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Wrapper>
  );
};

export default Navbar;